import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import ProfileItem from "./ProfileItem";

export default function CompanyDashboardProfile(props) {
    const {t, i18n} = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [userProfile, setUserProfile] = useState({});


    let initUserProfile = () => {
        let user_profile = window.user_profile;
        console.log('user_profile', user_profile);
        if (user_profile) {
            setUserProfile(user_profile)
        }
    }

    useEffect(
        () => {
            initUserProfile();
        },
        [props]
    );

    return (
         <ProfileItem profile={userProfile} profileType='USER'/>
    );
}
